import { Component, OnDestroy, OnInit } from '@angular/core';
import { FooterComponent } from '../../../../landing-page-v2/components/footer/footer.component';
import { HeaderComponent } from '../../../../landing-page-v2/components/header/header.component';
import { FixedCallComponent } from '../../fixed-call/fixed-call.component';

@Component({
  selector: 'app-auto-industry',
  templateUrl: './auto-industry.component.html',
  styleUrls: ['./auto-industry.component.scss'],
  standalone: true,
  imports: [HeaderComponent, FooterComponent, FixedCallComponent],
})
export class AutoIndustryComponent implements OnInit, OnDestroy {
  constructor() {}

  ngOnInit(): void {}

  ngOnDestroy(): void {}
}
